export default class MissingAttributeFromApiException extends Error {
  constructor(message) {
    super(message);
    this.name = 'MissingAttributeFromApiException';
  }
}
